import ClientTile, {
  ClientTileVariants,
} from 'components/client-tile/clientTile';
import React from 'react';
import { useStore } from 'store';
import { iCompanyData, iState } from 'types';
import styles from './clientsList.module.scss';

interface iProps {
  className?: string;
}

function ResellerClients(props: iProps): JSX.Element {
  const { className } = props;
  const [state]: [iState] = useStore();
  const { resellerClients } = state.homePage || {};

  return (
    <div className={`${className} ${styles.clientView}`}>
      {resellerClients.map((i: iCompanyData) => (
        <ClientTile variant={ClientTileVariants.ResellerClients} data={i} />
      ))}
    </div>
  );
}

ResellerClients.defaultProps = {
  className: '',
};

export default ResellerClients;
